// src/app/rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
// Update the import path below if the alias '@' is not configured in tsconfig.json
// Update the import path below to the correct location of authSlice
import { authReducer } from '@/features/auth/state/auth-state/authSlice';
import { tenantReducer } from '@/features/auth/state/tenant-state/tenantSlice';
import { uiReducer } from '@/features/auth/state/ui-state/uiSlice';
import themeReducer from '@/features/shared/state/themeSlice';
import playerReducer from '@/features/music/player/playerSlice';

// Root reducer combining all feature reducers
export const rootReducer = combineReducers({
  auth: authReducer,
  tenant: tenantReducer,
  ui: uiReducer,
  theme: themeReducer,
  player: playerReducer, // ephemeral music player UI state (not persisted)
});

// Export root reducer type
export type RootState = ReturnType<typeof rootReducer>;

// Create a function to reset the entire state
import { AnyAction } from 'redux';

export const createRootReducer = () => {
  return (state: RootState | undefined, action: AnyAction) => {
    // Reset state on logout
    if (action.type === 'auth/logout/fulfilled') {
      // Keep only essential data
      const { tenant } = state || { tenant: { current: null } };
      state = { tenant: { current: tenant.current } } as RootState;
    }
    return rootReducer(state, action);
  };
};

// Export the wrapped reducer
export default createRootReducer();